export const addDisableActiveRoute = (routes, routes_active) => {
  let result = []
  if (routes_active.length != 0) {
    for (let i of routes) {
      let obj = { ...i }
      obj.disabled = routes_active.some(k => k.route_and_type == i.route_and_type)
      result.push(obj)
    }
  } else { result = [ ...routes ] }
  return result
}

export const addColorRoutes = (routes, colorFn) => {
  return routes.map(i => {
    return {
      ...i,
      color: colorFn(i, routes)
    }
  })
}